export default __webpack_public_path__ + "static/media/V344_V346_22A346C.7f1a8389.STEP";